import { render, staticRenderFns } from "./ledgerLogDetail.vue?vue&type=template&id=179d2f4b&scoped=true"
import script from "./ledgerLogDetail.vue?vue&type=script&lang=js"
export * from "./ledgerLogDetail.vue?vue&type=script&lang=js"
import style0 from "./ledgerLogDetail.vue?vue&type=style&index=0&id=179d2f4b&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179d2f4b",
  null
  
)

export default component.exports